import CallMitraFlowStates from '../../constants/CallMitraFlowStates';

export default {
  offset: 0,
  jobs: [],
  isAPIProgress: false,
  isJAAPIProgress: false,
  selectedJob: {},
  jobApplications: [],
  selectedJobRoles: [],
  isSalarySliderVisible: false,
  isCitySelectionVisible: false,
  isJobRoleSelectionVisible: false,
  selectedSalary: 10000,
  selectedCity: {
    id: process.env.REACT_APP_BANGALORE_CITY_ID,
    name: 'Bengaluru',
    photoUrl: 'https://uploads-a.vahan.co/E12Mf4-bangalore.jpg',
  },
  selectedJobApplication: '',
  trackInfo: [],
  selectedLocalities: [],
  isLocalityVisible: false,
  userSettings: {
    whatsAppOptIn: false,
    notifications: false,
    addToHomeScreen: false,
  },
  isLoadingUserSettings: false,
  isWorkAreaVisible: false,
  isLoginPopupVisible: false,
  isOtpPopupVisible: false,
  kookooBridgeNumber: process.env.REACT_APP_KOOKOO_BRIDGE_NUMBER,
  callMitraFlowState: CallMitraFlowStates.NOT_VISIBLE,
  selectedJobForCall: {},
  callingThroughApplyFlow: false,
};
